/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Tools_EyebrowInputs */

const en_platform_tools_eyebrow = /** @type {(inputs: Platform_Tools_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free tools`)
};

const zh_hans1_platform_tools_eyebrow = /** @type {(inputs: Platform_Tools_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费工具`)
};

const pt_br2_platform_tools_eyebrow = /** @type {(inputs: Platform_Tools_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas grátis`)
};

const es_platform_tools_eyebrow = /** @type {(inputs: Platform_Tools_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas gratis`)
};

const fr_platform_tools_eyebrow = /** @type {(inputs: Platform_Tools_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils gratuits`)
};

const de_platform_tools_eyebrow = /** @type {(inputs: Platform_Tools_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Tools`)
};

const ru_platform_tools_eyebrow = /** @type {(inputs: Platform_Tools_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатные инструменты`)
};

const it_platform_tools_eyebrow = /** @type {(inputs: Platform_Tools_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti gratuiti`)
};

/**
* | output |
* | --- |
* | "Free tools" |
*
* @param {Platform_Tools_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_tools_eyebrow = /** @type {((inputs?: Platform_Tools_EyebrowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Tools_EyebrowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_tools_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_platform_tools_eyebrow(inputs)
	if (locale === "es") return es_platform_tools_eyebrow(inputs)
	if (locale === "fr") return fr_platform_tools_eyebrow(inputs)
	if (locale === "de") return de_platform_tools_eyebrow(inputs)
	if (locale === "ru") return ru_platform_tools_eyebrow(inputs)
	if (locale === "it") return it_platform_tools_eyebrow(inputs)
	return en_platform_tools_eyebrow(inputs)
});